



















import Vue from 'vue';

Vue.config.devtools = true;

export default Vue.extend({
    name: 'App',
    data: () => ({
        info: {},
        meta: {
            env: 'l',
            version: '0.0.0',
            buildTimestamp: '',
        },
    }),
    mounted() {
        this.meta = {
            env: (process.env.NODE_ENV || 'local').substr(0, 1),
            version: process.env.VUE_APP_VERSION!,
            buildTimestamp: process.env.VUE_APP_BUILD_TIMESTAMP!,
        };

        this.$nextTick(() => {
            const preloader = document.getElementById('app-preloader');
            if (preloader) preloader.style.display = 'none';
        });
    },
});
